import React from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './LightButton.module.css';

const variantClass = {
    primary: styles.primary,
    tertiary: styles.tertiary,
    row: styles.row,
};

export const LightButton = React.forwardRef(
    ({ type, dataTestId, caption, to, variant, size, raised, negativeMargin, textCenter, disabled, className, ...rest }, ref) => {
        const classes = clsx(
            styles.button,
            variantClass[variant ?? 'primary'],
            size === 'tight' && styles.tight,
            raised && styles.raised,
            negativeMargin && styles.negativeMargin,
            textCenter && styles.textCenter,
            disabled && styles.disabled,
            className,
        );

        if (type === 'link') {
            return (
                <a ref={ref} data-testid={dataTestId} className={classes} {...rest}>
                    {caption}
                </a>
            );
        }
        if (type === 'reactLink') {
            return (
                <Link ref={ref} data-testid={dataTestId} to={to ?? '#'} className={classes} {...rest}>
                    {caption}
                </Link>
            );
        }
        return (
            <button ref={ref} type={type} data-testid={dataTestId} disabled={disabled} className={classes} {...rest}>
                {caption}
            </button>
        );
    },
);

LightButton.propTypes = {
    type: PropTypes.oneOf(['button', 'submit', 'link', 'reactLink']),
    variant: PropTypes.oneOf(['primary', 'tertiary', 'row']),
    size: PropTypes.oneOf(['tight', 'fit']),
    raised: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    disabled: PropTypes.bool,
    href: PropTypes.string,
    to: PropTypes.string,
    target: PropTypes.string,
    rel: PropTypes.string,
    title: PropTypes.string,
    tabIndex: PropTypes.string,
    form: PropTypes.string, // для того, чтобы можно было связывать кнопку submit по id с form, если она находится вне form (н-р в попапах)
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    dataTestId: PropTypes.string, // для html аттрибута data-testid (babel plugin "react-remove-properties")
    negativeMargin: PropTypes.bool, // чтобы выравнивать row-кнопки по контенту
    onClick: PropTypes.func,
    textCenter: PropTypes.bool,
    className: PropTypes.string,
};
